module.exports = __webpack_public_path__ + "static/media/const-prot(1).ea929e03.pdf";